import { useTranslation } from "react-i18next";
import { AuthShell } from "@/features/auth/AuthShell";
import { LoginForm } from "@/features/auth/LoginForm";

export default function Login() {
  const { t } = useTranslation();
  return (
    <AuthShell title={t("login.title")} subtitle={t("login.subtitle")}>
      <LoginForm />
    </AuthShell>
  );
}
